import gql from 'graphql-tag';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';
const CREATE_CLASSROOM = gql`
  mutation createClassroom($classroom: ClassroomCreateInput!) {
    createClassroom(data: $classroom) {
      ...BaseClassroom
    }
  }
  ${CLASSROOM_FRAGMENT}
`;

export default CREATE_CLASSROOM;
